export const getClientId = () => {
    const client = localStorage.getItem("currentUser")
    if (client) {
        const clientInfo = JSON.parse(client)
        return clientInfo.clientId
    }
    else {
        return undefined
    }
}